export default "__VITE_ASSET__2b3b97f1__"